import { environment } from "src/environments/environment";

export const activeAppInfo = {
    tokenname: "ieposonapp-token",
    floatId: "ieposonapp-float",
    userinfo: "ieposonapp-user",
    baseurl: environment.BASEURL
}